import Slider from '../utils/slider'

const TEASER_BUTTON_INACTIVE_CLASS = 'teaser__swiper-controller--inactive'

class TeaserSlider {
  constructor() {
    this.teaserSliders = document.querySelectorAll('.teaser__slider')
    this.teaserSliders.forEach(slider => {
      new Slider({
        parent: slider,
        buttonInactiveClass: TEASER_BUTTON_INACTIVE_CLASS,
      })
    })
  }
}

export default TeaserSlider
